import axios from 'axios';

const PREFIJO="/api/Agnc/";

export default {
    agencias(formualrio) {
        const dto={ndt3:formualrio.id,bdt3:true,ndt5:process.env.VUE_APP_API_KEY_TIPO};
        return axios.post(`${PREFIJO}VmLsAgn`,dto);
    }
};
